export default "__VITE_ASSET__DiN2tpwY__"